module.exports = __webpack_public_path__ + "img/contest-0-pc.10c55b66.png";